module.exports = __webpack_public_path__ + "img/tul.739a626b.svg";